import { Button, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

type SchemaLoadingFailureAlertBoxProps = {
  onRefresh?: () => void;
  onClose?: () => void;
};

export function SchemaLoadingFailureAlertBox(props: SchemaLoadingFailureAlertBoxProps) {
  return (
    <Alert
      severity="error"
      sx={{ mb: 2, mt: 2, mx: 0.5, boxShadow: 2 }}
    >
      <AlertTitle>The device configuration form cannot be loaded</AlertTitle>

      <Typography paragraph>
        If you continue experiencing this issue, please verify that your device is running the latest firmware version.
        <br />
        The system may resolve this automatically through scheduled updates, or you may contact technical support for assistance.
      </Typography>

      <Typography component="div">
        {props.onRefresh && <Button onClick={props.onRefresh}>Retry</Button>}

        {props.onClose && <Button onClick={props.onClose}>Close</Button>}
      </Typography>
    </Alert>
  );
}
